<div class="event-streaming-detail-container" *ngIf="kafkaConfiguration">
  <div class="detail-content">
    <!-- Connection Parameters Section -->
    <div class="section-header">
      <h3>{{ 'EVENT_STREAMING.CONNECTION_PARAMETERS' | translate }}</h3>
    </div>

    <div class="connection-parameters">
      <div class="form-row">
        <div class="form-group full-width">
          <label class="required">{{ 'EVENT_STREAMING.BOOTSTRAP_SERVERS' | translate }}</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="kafkaConfiguration.environment.connection.bootstrapServers"
            placeholder="20.83.151.64:9092" />
          <small class="form-text">{{ 'EVENT_STREAMING.BOOTSTRAP_SERVERS_HELP' | translate }}</small>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group full-width">
          <label class="required">{{ 'EVENT_STREAMING.SECURITY_PROTOCOL' | translate }}</label>
          <select
            class="form-control"
            [(ngModel)]="kafkaConfiguration.environment.connection.securityProtocol">
            <option *ngFor="let option of securityProtocolOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- SASL Credentials Section (shown when SASL is selected) -->
      <div class="credentials-section" *ngIf="kafkaConfiguration.environment.connection.securityProtocol?.includes('SASL')">
        <div class="section-subheader">
          <h4>{{ 'EVENT_STREAMING.SASL_CREDENTIALS' | translate }}</h4>
        </div>

        <div class="form-row">
          <div class="form-group half-width">
            <label class="required">{{ 'EVENT_STREAMING.USER' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="kafkaConfiguration.environment.connection.saslUsername"
              placeholder="$Connection" />
          </div>

          <div class="form-group half-width">
            <label class="required">{{ 'EVENT_STREAMING.PASSWORD' | translate }}</label>
            <input
              type="password"
              class="form-control"
              [(ngModel)]="kafkaConfiguration.environment.connection.saslPassword"
              placeholder="••••••••••••" />
          </div>
        </div>
      </div>

      <!-- Test Connection Button -->
      <div class="test-connection-section">
        <bzg-button-secondary size= "'s'" (click)="testConnection()">
            {{ 'EVENT_STREAMING.TEST_CONNECTION' | translate }}
         </bzg-button-secondary>     
      </div>
    </div>

    <!-- Consumer Instances Management Section -->
    <div class="section-header">
      <h3>{{ 'EVENT_STREAMING.CONSUMER_INSTANCES_MANAGEMENT' | translate }}</h3>
    </div>

    <div class="consumer-instances-table">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'EVENT_STREAMING.CONSUMER_STATUS' | translate }}</th>
            <th>{{ 'EVENT_STREAMING.TOPIC_OF_KAFKA' | translate }}</th>
            <th>{{ 'EVENT_STREAMING.BIZAGI_ACTION' | translate }}</th>
            <th>{{ 'EVENT_STREAMING.TARGET_PROCESS' | translate }}</th>
            <th>{{ 'EVENT_STREAMING.MAP_ATTRIBUTE' | translate }}</th>
            <th>{{ 'EVENT_STREAMING.CONSUMER_GROUP_ID' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let setting of kafkaConfiguration.environment.inboundSettings; let i = index">
            <td>
              <div class="toggle-container">
                <bzg-switch id="isEnable" class="bz-space--stack-s bz-space--inline-s" [(ngModel)]="setting.overridableSettings.enabled"></bzg-switch>
                <span class="toggle-label">
                  {{ setting.overridableSettings.enabled ? 
                     ('EVENT_STREAMING.ENABLED' | translate) : 
                     ('EVENT_STREAMING.DISABLED' | translate) }}
                </span>
              </div>
            </td>
            <td>
              <span class="form-value">{{ setting.topicName || '-' }}</span>
            </td>
            <td>
                <span class="form-value">{{ setting.action.actionType || '-' }}</span>
            </td>
              <td>
                <span class="form-value">{{ setting.action.targetResource || '-' }}</span>
            </td>
            <td>
              <span class="form-value">{{ setting.action.xpathName || '-' }}</span>
            </td>
            <td>
              <span class="form-value">{{ setting.action.consumerGroupId || '-' }}</span>
            </td>
          </tr>
          <tr *ngIf="!kafkaConfiguration.environment.inboundSettings || 
                     kafkaConfiguration.environment.inboundSettings.length === 0">
            <td colspan="6" class="text-center empty-state">
              <bzg-icon name="info-circle"></bzg-icon>
              <p>{{ 'EVENT_STREAMING.NO_CONSUMERS_CONFIGURED' | translate }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
